
import { socketManager } from './socketManager';

let socketInstance = null;

export const initSocketService = ({ roomId, studentId, teacherId, socketToken, mode, cb, connectCb }) => {
    console.log(`called initsocket service with params`, studentId);
    const uid = mode === 'teacher' ? teacherId : studentId;
    console.log(`socket manager`, socketManager);
    socketInstance = socketManager({
        uid, roomId, socketToken: socketToken || btoa(JSON.stringify({
            uid: uid,
            roomId: roomId
        }))
    });
    socketInstance.onConnect(connectCb);
    socketInstance.onMessage(cb);
    return socketInstance
}

export const closeSocketService = () => {
    if(socketInstance)
        socketInstance.close();
}

export const sendSocketMessage = (msg) => {
    socketInstance.send(msg);
}

export const getLatestXml = (id, target, source) => {
    socketInstance.send({
        type: "GET_LATEST_XML",
        state: {appletId: id, source},
        target: [target]
    });
}